import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center flex-nowrap" }
const _hoisted_2 = { class: "caption white-space-nowrap" }
const _hoisted_3 = { class: "flex align-items-center ml-s2" }
const _hoisted_4 = { class: "text-sm white-space-nowrap" }

import Spinner from '@/components/Spinner.vue';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'UnstackingFeeTimer',
  props: {
    percent: null,
    time: null
  },
  emits: ["endTimer"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'endTimer', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  percent: string;
  time: number;
}



const { t } = useI18n();
let currentTime;
const endTime = new Date(props.time * 1000).getTime();
const timer = () => {
  currentTime = new Date().getTime();
  if (currentTime > endTime) {
    emits('endTimer', false);
    return null;
  } else {
    let distance = endTime - currentTime;
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let min = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    return days + 'd : ' + hours + 'h : ' + min + 'm';
  }
};
onMounted(() => setInterval(timer, 1000));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.percent) + "%  " + _toDisplayString(_unref(t)('yieldPool.unstakingFeeUntill')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(timer()), 1),
      _createVNode(Spinner, {
        size: "20",
        class: "ml-s2"
      })
    ])
  ]))
}
}

})